
import { computed, defineComponent, PropType, ref } from 'vue'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { useRoute } from 'vue-router'
import AgreementEditContactInfosDialog from '@/components/agreements/dialogs/agreement-contact-infos/edit-contacts-dialog.vue'
import { AgreementContactPerson } from '@/modules/agreements'
export default defineComponent({
    name: 'agreements-open-dialog-contact-persons',
    components: {
    },
    props: {
        agreementId: {
            type: String,
            required: true
        },
        agreementContactPersons: {
            type: Array as PropType<AgreementContactPerson[]>
        },
        editingDisabled: {
            type: Boolean,
            default: false
        }
    },
    setup (props) {
        const $q = useQuasar()
        const route = useRoute()

        const contactPersons = ref(props.agreementContactPersons)

        const onValueUpdated = (newValue: AgreementContactPerson[]) => {
            contactPersons.value = newValue
        }

        const onChangeContactInfos = () => {
            $q.dialog({
                component: AgreementEditContactInfosDialog,
                componentProps: {
                    agreementId: props.agreementId,
                    agreementContactPersons: contactPersons.value,
                    contacts: contactPersons.value,
                    contactTypes: ['Operative', 'Contract', 'Admin'],
                    id: route.params.agreementId,
                    updateCallback: onValueUpdated
                }
            })
        }

        return {
            contactPersons: computed(() => contactPersons.value),
            onChangeContactInfos,
            onValueUpdated
        }
    }
})
